import {getUserLS} from '@asocial/fe-utils'
import React, {useEffect} from 'react'
import {CursorType} from '../types'
import {useScroll} from './useScroll'

type useVirtualScrollProps = {
  ref: React.RefObject<HTMLDivElement> | HTMLDivElement | null
  isFetching: boolean
  isError: boolean
  load: Function
  cursor: CursorType
  nextPagePx?: number
  skip?: boolean
}

export function useVirtualScroll({
  ref,
  isFetching,
  load,
  isError,
  cursor,
  nextPagePx = 300,
  skip
}: useVirtualScrollProps): void {
  const scroll = useScroll(ref)
  const user = getUserLS()

  useEffect(() => {
    if (!user) return

    const htmlElement = ref instanceof HTMLDivElement ? ref : ref?.current
    if (!htmlElement) return

    if (isFetching || cursor == null || isError) return

    if (scroll > htmlElement.scrollHeight - htmlElement.offsetHeight - nextPagePx) {
      !skip && load().catch(console.error)
    }
  }, [ref, load, cursor, isFetching, scroll, isError, skip])
}